module.exports = __webpack_public_path__ + "img/iPipelineLogo.cb8f2efe.png";